import {Dayjs} from 'dayjs';
import {json, JsonMappers} from '../../../core/data-source/json.mapper';
import {DictionaryRecord} from '../../../records/dictionary.record';

export class OrderItemsDeliveryReportFilterRecord {
    @json({
        value: null,
        mapper: JsonMappers.InstanceOf(() => DictionaryRecord)
    })
    areaOfControl: DictionaryRecord;

    @json({
        jsonName: 'destinationDateStart',
        mapper: JsonMappers.Dayjs
    })
    dateFrom: Dayjs;

    @json({
        jsonName: 'destinationDateEnd',
        mapper: JsonMappers.Dayjs
    })
    dateTo: Dayjs;

    @json({
        value: []
    })
    orderItemStatuses: string[];
}
